export const OBSERVER_PRIVATE = Symbol('observer-private');
//# sourceMappingURL=privates.js.map